import { FieldDefinition } from "./fieldDefinitions";

// 1. Το DTO όπως έρχεται από το Backend (συμπεριλαμβάνει την περιγραφή για προβολή)
export interface PatientAllergyDto {
  patAllId: number;
  allergyId: number;
  patientId: number;
  patAllRemarks?: string | null;
  allergyDescr: string;
  allergyRemarks?: string | null;
  active: boolean;
}

export const patientAllergyKeyId = "patAllId" as const;

// 2. Τα δεδομένα που στέλνει η Φόρμα (χρειάζεται το ID για την αποθήκευση)
export type patientAllergyFormData = {
  allergyId: number | string;
  patAllRemarks?: string | null;
  active?: boolean;
};

// 3. Συνάρτηση που επιστρέφει τα fields για τη Φόρμα (Χρησιμοποιεί Select με options)
export const getPatientAllergyFields = (
  allergyOptions: { value: number | string; label: string }[] = [],
): FieldDefinition<patientAllergyFormData>[] => [
  {
    name: "allergyId",
    label: "Αλλεργία",
    type: "select",
    required: true,
    options: allergyOptions,
  },
  {
    name: "patAllRemarks",
    label: "Παρατηρήσεις Ασθενούς",
    type: "text",
    required: false,
  },
];

export const patientAllergyFormDataKeys: (keyof patientAllergyFormData)[] = [
  "allergyId",
  "patAllRemarks",
];
